import IconButton from '#components/a/IconButton'
import i18n from 'i18next'
import PropTypes from 'prop-types'
import React from 'react'
import Headline from '../a/Headline'
import Modal from './Modal'

const COMMENT_MIN_LENGTH = 1
const COMMENT_MAX_LENGTH = 280

const ThumbsUpUnicode = '\u{1F44D}'
const HeartUnicode = '\u{1F49B}'
const EmojiUnicode = '\u{1F600}'

export default class CommentModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      commentText: '',
      showEmojis: false,
    }
    this.button = React.createRef()
    this.textarea = React.createRef()
    this.dialogRef = React.createRef()
  }

  componentDidMount() {
    if (this.props.commentText) {
      this.setState({commentText: this.props.commentText})
    }
  }

  handleCommentInputChange = text => {
    if (text.length <= COMMENT_MAX_LENGTH) {
      this.setState({
        commentText: text,
      })
    }
  }

  handleCommentInputChangeFromEvent = event => {
    this.handleCommentInputChange(event.target.value)
  }

  insertText = textToInsert => {
    const currentTextarea = this.textarea.current
    const {commentText} = this.state
    const {selectionEnd} = currentTextarea
    const result = commentText.substring(0, selectionEnd) + textToInsert + commentText.substring(selectionEnd)
    this.handleCommentInputChange(result)
  }

  showEmojiModal = () => {
    this.setState({showEmojis: true})
    setTimeout(() => {
      // Timeout is needed because otherwise the modal cancels itself immediately
      window.addEventListener('click', this.handleBackdropClick, true)
    }, 5)
  }

  handleBackdropClick = event => {
    const dialog = this.dialogRef.current
    const rect = dialog.getBoundingClientRect()
    if (
      rect.left > event.clientX ||
      rect.right < event.clientX ||
      rect.top > event.clientY ||
      rect.bottom < event.clientY
    ) {
      this.closeEmojiSelection()
    }
  }

  closeEmojiSelection = () => {
    window.removeEventListener('click', this.handleBackdropClick, true)
    this.setState({showEmojis: false})
  }

  render() {
    const {commentText, showEmojis} = this.state
    const {id, confirmCallback, trigger, title, placeholder, confirmText} = this.props

    const commentReject = commentText.length < COMMENT_MIN_LENGTH || commentText.length > COMMENT_MAX_LENGTH

    return (
      <Modal
        id={id}
        trigger={trigger}
        confirmCallback={() => confirmCallback(commentText)}
        confirmButtonDisabled={commentReject}
        confirmText={confirmText}
        hasCloseButton>
        <div className="commentModal">
          <Headline modifier="article" importance={2} text={i18n.t('ablehnung_kommentar_title')} />

          <span className="commentModal__lengthHint">
            {i18n.t('remaining_chars_hint', {chars: COMMENT_MAX_LENGTH - commentText.length})}
          </span>
        </div>
        <div className="text-container">
          <textarea
            ref={this.textarea}
            className="commentModal__textbox"
            value={commentText}
            onChange={elem => this.handleCommentInputChangeFromEvent(elem)}
            placeholder={placeholder}></textarea>
          <div className="bottom-right">
            <IconButton icon="stylizedEmoji" event={() => this.showEmojiModal()} />
          </div>
          <div ref={this.dialogRef} className={'emoji-modal' + (!showEmojis ? ' hidden' : '')}>
            <IconButton event={() => this.insertText(EmojiUnicode)} icon="emoji" ref={this.button} />
            <IconButton event={() => this.insertText(ThumbsUpUnicode)} icon="thumbsUp" ref={this.button} />
            <IconButton event={() => this.insertText(HeartUnicode)} icon="heart" ref={this.button} />
          </div>
        </div>
      </Modal>
    )
  }
}

CommentModal.propTypes = {
  id: PropTypes.string,
  trigger: PropTypes.node,
  commentText: PropTypes.string,
  confirmCallback: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  confirmText: PropTypes.string.isRequired,
}
